export const localePrice = (price) =>
  price !== undefined ? `${price.toLocaleString("ru-RU")} ₽` : "";
